// @ts-nocheck


import React from 'react';
import styled from 'styled-components';

import notification from 'antd/lib/notification';

import { licensePlateChangeApi } from './../../../../../lib/api';
import { formatDate } from './../../../../../lib/helpers';

import { Table } from './../../../../../components/ui';
import { Header, Section, Panel } from './../../../../../components/layout';
import Breadcrumbs, {
  Crumb } from
'./../../../../../components/layout/Breadcrumbs';

import {
  LICENSE_PLATE_CHANGE_COLUMNS as COLUMNS,
  Filter } from
'./../../../../services/licensePlateChange';

import { GroupListTable } from './../../lib';

const StyledPanel = styled(Panel).withConfig({ displayName: "MonthList__StyledPanel", componentId: "sc-1mr7th7-0" })(["padding-top:0;"]);



export default class extends GroupListTable {
  fetch = async (page = 1) => {
    const params = {
      ...super.fetch(page)
    };
    try {
      const data = await licensePlateChangeApi.fetchLicensePlateChanges({
        ...params,
        ...this.getDate(params.period)
      });
      this.setState({ ...data, loading: false, page });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  render() {
    const { location } = this.props;
    const { data, totalCount, pageSize, page, loading, filter } = this.state;
    const { period } = filter;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/budget/execution/license-plate-change">
                Замена ГРЗ
              </Crumb>
              <Crumb>Сравнение данных</Crumb>
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>Замена ГРЗ за {formatDate(period, 'MMMM YYYY')}</h1>
        </StyledPanel>
        <Section>
          <Filter
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter}
            filter={filter} />

          <Table
            fetch={this.fetch}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }}
            loading={loading}
            columns={COLUMNS}
            data={data} />

        </Section>
      </>);

  }
}
